/**
 * 年月をスラッシュ区切りの表示用フォーマットに変換する
 *
 * @description 年と月を "yyyy/mm" 形式の文字列に変換する
 *
 * @param {number} year - 年（例: 2024）
 * @param {number} month - 月（1-12）
 * @returns {string} フォーマット済み年月文字列（例: "2024/01"）
 *
 * @example
 * formatYearMonthToSlash(2024, 1);  // "2024/01"
 * formatYearMonthToSlash(2024, 12); // "2024/12"
 */
export function formatYearMonthToSlash(year: number, month: number): string {
  return `${year}/${String(month).padStart(2, '0')}`;
}
